import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup, AvInput, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import {getEntities as getTransferReasons} from 'app/entities/transfer-reason/transfer-reason.reducer';
import 'app/entities/registration/registration.scss';
import RegistrationButtons from './registration-buttons';

interface IReasonForTransferProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const ReasonForTransfer: React.FC<IReasonForTransferProps> = (props: IReasonForTransferProps) => {
  const {patientCase, transferReasons, transferReasonsLoading, countryId} = props;

  useEffect(() => {
    if (countryId) {
      props.getTransferReasons(countryId);
    }
  }, [countryId]);

  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedReasonId = e.target.value;
    props.setRegistrationData({patientCase: {...patientCase, reasonForTransferId: selectedReasonId}});
  };

  const handleReasonDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setRegistrationData({patientCase: {...patientCase, reasonForTransferDescription: e.target.value}});
  };

  // Check if the last entry (highest displayOrder) is selected
  const sortedReasons = transferReasons
    .filter(reason => reason.isActive !== false)
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
  const lastReason = sortedReasons[sortedReasons.length - 1];
  const isOtherSelected = lastReason && patientCase.reasonForTransferId === lastReason.id;

  useEffect(() => {
    // Next step is always Patient Info

  }, []);

  if (transferReasonsLoading) {
    return <div>Loading transfer reasons...</div>;
  }

  return (
    <div>
      <h2 className="mb-4">Reason for transfer?</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <AvRadioGroup name="radio-button-group" required value={patientCase.reasonForTransferId}
                      errorMessage="Please select an option">
          <Row>
            {sortedReasons.map((reason, index) => (
              <Col md="4" key={reason.id || index} className="mb-3">
                <Label className="radio-button-label">
                  <AvRadio
                    name="reasonForTransfer"
                    value={reason.id}
                    onChange={handleReasonChange}
                    className="radio-button-input"
                    required
                  />
                  {reason.enTransferReason}
                </Label>
              </Col>
            ))}
          </Row>
        </AvRadioGroup>
        {isOtherSelected && (
          <Row>
            <Col md="12">
              <AvGroup>
                <AvInput
                  type="text"
                  name="reasonDetails"
                  id="reasonDetails"
                  placeholder="Reason for transfer"
                  required
                  value={patientCase.reasonForTransferDescription || ''}
                  onChange={handleReasonDetailsChange}
                />
                <small className="form-text text-muted">Reason for onward transfer is mandatory before the
                  transfer.</small>
              </AvGroup>
            </Col>
          </Row>
        )}
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  patientCase: state.registration.entity.patientCase,
  countryId: state.registration.entity.countryId,
  transferReasons: state.transferReason.entities,
  transferReasonsLoading: state.transferReason.loading,
});

const mapDispatchToProps = {
  setRegistrationData,
  getTransferReasons,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ReasonForTransfer);
